(function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var emptyList = kotlin_kotlin.$_$.w5;
  var Unit_getInstance = kotlin_kotlin.$_$.k4;
  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.a4;
  var toString = kotlin_kotlin.$_$.ca;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.a2;
  var classMeta = kotlin_kotlin.$_$.v8;
  var Unit = kotlin_kotlin.$_$.cd;
  var getKClass = kotlin_kotlin.$_$.e;
  var objectMeta = kotlin_kotlin.$_$.y9;
  var interfaceMeta = kotlin_kotlin.$_$.e9;
  var equals = kotlin_kotlin.$_$.x8;
  var Collection = kotlin_kotlin.$_$.m4;
  var isInterface = kotlin_kotlin.$_$.n9;
  var getKClassFromExpression = kotlin_kotlin.$_$.d;
  var THROW_CCE = kotlin_kotlin.$_$.vc;
  var KClass = kotlin_kotlin.$_$.ma;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.i5;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.x;
  var copyToArray = kotlin_kotlin.$_$.u5;
  var Companion_getInstance = kotlin_kotlin.$_$.b4;
  var hashCode = kotlin_kotlin.$_$.d9;
  //endregion
  //region block: pre-declaration
  AbstractKClassTypeToken.prototype = Object.create(AbstractTypeToken.prototype);
  AbstractKClassTypeToken.prototype.constructor = AbstractKClassTypeToken;
  JSKClassTypeToken.prototype = Object.create(AbstractKClassTypeToken.prototype);
  JSKClassTypeToken.prototype.constructor = JSKClassTypeToken;
  JSKTypeTypeToken.prototype = Object.create(AbstractTypeToken.prototype);
  JSKTypeTypeToken.prototype.constructor = JSKTypeTypeToken;
  //endregion
  function AbstractKClassTypeToken(type) {
    AbstractTypeToken.call(this);
    this.d4m_1 = type;
  }
  AbstractKClassTypeToken.prototype.e4m = function () {
    return this.f4m();
  };
  AbstractKClassTypeToken.prototype.g4m = function () {
    return this.h4m();
  };
  AbstractKClassTypeToken.prototype.i4m = function () {
    return this;
  };
  AbstractKClassTypeToken.prototype.j4m = function () {
    return true;
  };
  AbstractKClassTypeToken.prototype.k4m = function () {
    return emptyList();
  };
  AbstractKClassTypeToken.prototype.l4m = function () {
    var tmp$ret$0;
    // Inline function 'kotlin.emptyArray' call
    tmp$ret$0 = [];
    return tmp$ret$0;
  };
  AbstractKClassTypeToken.prototype.m4m = function (typeToken) {
    if (this.equals(typeToken))
      return true;
    if (this.d4m_1.equals(PrimitiveClasses_getInstance().dg()))
      return true;
    return false;
  };
  AbstractKClassTypeToken.prototype.n4m = function (other) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(other instanceof AbstractKClassTypeToken)) {
      var tmp$ret$0;
      // Inline function 'kotlin.require.<anonymous>' call
      tmp$ret$0 = 'Failed requirement.';
      var message = tmp$ret$0;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    if (!this.d4m_1.equals(other.d4m_1))
      return false;
    return true;
  };
  AbstractKClassTypeToken.prototype.o4m = function () {
    return this.d4m_1.hashCode();
  };
  AbstractKClassTypeToken.$metadata$ = classMeta('AbstractKClassTypeToken', undefined, undefined, undefined, undefined, AbstractTypeToken.prototype);
  function Companion() {
    Companion_instance = this;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'org.kodein.type.erased' call
    tmp$ret$0 = erased(getKClass(Unit));
    tmp.p4m_1 = tmp$ret$0;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'org.kodein.type.erased' call
    tmp$ret$1 = erased(PrimitiveClasses_getInstance().dg());
    tmp_0.q4m_1 = tmp$ret$1;
  }
  Companion.prototype.e1y = function () {
    return this.q4m_1;
  };
  Companion.$metadata$ = objectMeta('Companion');
  var Companion_instance;
  function Companion_getInstance_0() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function TypeToken() {
  }
  TypeToken.$metadata$ = interfaceMeta('TypeToken');
  function Companion_0() {
    Companion_instance_0 = this;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'org.kodein.type.erased' call
    tmp$ret$0 = erased(getKClass(Unit));
    tmp.r4m_1 = tmp$ret$0;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'org.kodein.type.erased' call
    tmp$ret$1 = erased(PrimitiveClasses_getInstance().dg());
    tmp_0.s4m_1 = tmp$ret$1;
  }
  Companion_0.prototype.e1y = function () {
    return this.s4m_1;
  };
  Companion_0.$metadata$ = objectMeta('Companion');
  var Companion_instance_0;
  function Companion_getInstance_1() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function AbstractTypeToken() {
    Companion_getInstance_1();
  }
  AbstractTypeToken.prototype.m4m = function (typeToken) {
    if (this.equals(typeToken) ? true : this.equals(Companion_getInstance_1().s4m_1))
      return true;
    var raw = this.i4m();
    if (equals(raw, typeToken.i4m())) {
      var thisParams = this.l4m();
      var tmp$ret$0;
      // Inline function 'kotlin.collections.isEmpty' call
      tmp$ret$0 = thisParams.length === 0;
      if (tmp$ret$0)
        return true;
      var tokenParams = typeToken.l4m();
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index = 0;
      var indexedObject = thisParams;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var item = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.kodein.type.AbstractTypeToken.isAssignableFrom.<anonymous>' call
        var tmp1 = index;
        index = tmp1 + 1 | 0;
        var tmp0__anonymous__q1qw7t = tmp1;
        var tokenParam = tokenParams[tmp0__anonymous__q1qw7t];
        if (!item.m4m(tokenParam))
          return false;
      }
      return true;
    }
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp1_any = typeToken.k4m();
      var tmp;
      if (isInterface(tmp1_any, Collection)) {
        tmp = tmp1_any.m();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$1 = false;
        break $l$block_0;
      }
      var tmp0_iterator = tmp1_any.d();
      while (tmp0_iterator.e()) {
        var element = tmp0_iterator.f();
        var tmp$ret$2;
        // Inline function 'org.kodein.type.AbstractTypeToken.isAssignableFrom.<anonymous>' call
        tmp$ret$2 = this.m4m(element);
        if (tmp$ret$2) {
          tmp$ret$1 = true;
          break $l$block_0;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  };
  AbstractTypeToken.prototype.toString = function () {
    return this.g4m();
  };
  AbstractTypeToken.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(!(other == null) ? isInterface(other, TypeToken) : false))
      return false;
    if (getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return this.n4m(other);
    if (!equals(this.i4m(), other.i4m()))
      return false;
    if (!this.j4m() ? true : !other.j4m()) {
      var tParams = this.l4m();
      var oParams = other.l4m();
      if (!(tParams.length === oParams.length))
        return false;
      var inductionVariable = 0;
      var last = tParams.length - 1 | 0;
      if (inductionVariable <= last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!equals(tParams[i], oParams[i]))
            return false;
        }
         while (inductionVariable <= last);
    }
    return true;
  };
  AbstractTypeToken.prototype.hashCode = function () {
    return this.o4m();
  };
  AbstractTypeToken.$metadata$ = classMeta('AbstractTypeToken', [TypeToken]);
  function JSKClassTypeToken(type) {
    AbstractKClassTypeToken.call(this, type);
  }
  JSKClassTypeToken.prototype.f4m = function () {
    var tmp0_elvis_lhs = this.d4m_1.te();
    return tmp0_elvis_lhs == null ? '(non-denotable type)' : tmp0_elvis_lhs;
  };
  JSKClassTypeToken.prototype.h4m = function () {
    var tmp0_elvis_lhs = this.d4m_1.te();
    return tmp0_elvis_lhs == null ? '(non-denotable type)' : tmp0_elvis_lhs;
  };
  JSKClassTypeToken.$metadata$ = classMeta('JSKClassTypeToken', undefined, undefined, undefined, undefined, AbstractKClassTypeToken.prototype);
  function JSKTypeTypeToken(type) {
    AbstractTypeToken.call(this);
    this.u4m_1 = type;
  }
  JSKTypeTypeToken.prototype.e4m = function () {
    return toString(this.u4m_1);
  };
  JSKTypeTypeToken.prototype.g4m = function () {
    return toString(this.u4m_1);
  };
  JSKTypeTypeToken.prototype.i4m = function () {
    var tmp = this.u4m_1.df();
    return new JSKClassTypeToken((!(tmp == null) ? isInterface(tmp, KClass) : false) ? tmp : THROW_CCE());
  };
  JSKTypeTypeToken.prototype.l4m = function () {
    var tmp$ret$5;
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$4;
    // Inline function 'kotlin.collections.map' call
    var tmp0_map = this.u4m_1.ef();
    var tmp$ret$3;
    // Inline function 'kotlin.collections.mapTo' call
    var tmp0_mapTo = ArrayList_init_$Create$(collectionSizeOrDefault(tmp0_map, 10));
    var tmp0_iterator = tmp0_map.d();
    while (tmp0_iterator.e()) {
      var item = tmp0_iterator.f();
      var tmp$ret$2;
      // Inline function 'org.kodein.type.JSKTypeTypeToken.getGenericParameters.<anonymous>' call
      var tmp0_safe_receiver = item.m6_1;
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        var tmp$ret$1;
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp$ret$0;
        // Inline function 'org.kodein.type.JSKTypeTypeToken.getGenericParameters.<anonymous>.<anonymous>' call
        tmp$ret$0 = typeToken(tmp0_safe_receiver);
        tmp$ret$1 = tmp$ret$0;
        tmp = tmp$ret$1;
      }
      var tmp1_elvis_lhs = tmp;
      tmp$ret$2 = tmp1_elvis_lhs == null ? Companion_getInstance_1().s4m_1 : tmp1_elvis_lhs;
      tmp0_mapTo.b(tmp$ret$2);
    }
    tmp$ret$3 = tmp0_mapTo;
    tmp$ret$4 = tmp$ret$3;
    var tmp1_toTypedArray = tmp$ret$4;
    tmp$ret$5 = copyToArray(tmp1_toTypedArray);
    return tmp$ret$5;
  };
  JSKTypeTypeToken.prototype.j4m = function () {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp0_all = this.u4m_1.ef();
      var tmp;
      if (isInterface(tmp0_all, Collection)) {
        tmp = tmp0_all.m();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = tmp0_all.d();
      while (tmp0_iterator.e()) {
        var element = tmp0_iterator.f();
        var tmp$ret$1;
        // Inline function 'org.kodein.type.JSKTypeTypeToken.isWildcard.<anonymous>' call
        tmp$ret$1 = element.equals(Companion_getInstance().j6());
        if (!tmp$ret$1) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  JSKTypeTypeToken.prototype.k4m = function () {
    return emptyList();
  };
  JSKTypeTypeToken.prototype.n4m = function (other) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(other instanceof JSKTypeTypeToken)) {
      var tmp$ret$0;
      // Inline function 'kotlin.require.<anonymous>' call
      tmp$ret$0 = 'Failed requirement.';
      var message = tmp$ret$0;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return equals(this.u4m_1, other.u4m_1);
  };
  JSKTypeTypeToken.prototype.o4m = function () {
    return hashCode(this.u4m_1);
  };
  JSKTypeTypeToken.$metadata$ = classMeta('JSKTypeTypeToken', undefined, undefined, undefined, undefined, AbstractTypeToken.prototype);
  function erasedOf(obj) {
    return new JSKClassTypeToken(getKClassFromExpression(obj));
  }
  function typeToken(type) {
    var tmp;
    if (type.ef().m()) {
      var tmp_0 = type.df();
      tmp = new JSKClassTypeToken((!(tmp_0 == null) ? isInterface(tmp_0, KClass) : false) ? tmp_0 : THROW_CCE());
    } else {
      tmp = new JSKTypeTypeToken(type);
    }
    return tmp;
  }
  function erased(cls) {
    return new JSKClassTypeToken(cls);
  }
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Companion_getInstance_0;
  _.$_$.b = TypeToken;
  _.$_$.c = erasedOf;
  _.$_$.d = typeToken;
  //endregion
  return _;
}(module.exports, require('./kotlin-kotlin-stdlib-js-ir.js')));

